export default {"src":"/_next/static/image/public/images/failure.9ea238446c592cda49d7df2d16e58e67.svg","height":131,"width":163};